<template>
  <div class="page">

      <div class="container">
        <div class="row">
          <h6 class="center-align">{{ $t("SETTINGS-INFO.ABOUT") }} {{$store.getters.getData.display_name}}</h6>
          <p v-if="$store.getters.getData.terms_url">{{ $t("SETTINGS-INFO.CONDITIONS") }}:
            <a  v-if="$store.getters.platform === 'browser'" :href="$store.getters.getData.terms_url" target="_blank">{{$store.getters.getData.terms_url}}</a>
            <span v-else >{{$store.getters.getData.terms_url}}</span>
          </p>
          <p v-else>{{$t('GENERAL.NO-CONTENT')}}</p>
          <span class="version">{{dataVersion.version}}</span>
        </div>
      </div>

  </div>
</template>

<script>
import Bus from '@/components/ControlBus'
import json from '@/../static/version.json'

export default {
  name: 'Info',
  data () {
    return {
      dataVersion: json
    }
  },
  mounted: function () {
    // keys control
    Bus.$on('key-back', this.keyBack)
  },
  methods: {
    keyBack () { this.$router.go(-1) }
  },
  beforeDestroy: function () {
    Bus.$off('key-back', this.keyBack)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.container
  color: #424242

  .row
    h6
      font-size: 2.6rem

    p
      font-size: 1.5rem
      margin-top: 5rem

    span.version
      position: absolute
      bottom: 0
      right: 0
      margin: 3rem
</style>



// WEBPACK FOOTER //
// src/pages/settings/Info.vue